<template>
  <section id="termsOfUse" class="terms section-show" style="height: auto!important;">
    <div class="container">

      <div>
        <h2> Пользовательское соглашение </h2>
        <p>в разработке</p>
      </div>

    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: 'TermsOfUsePage',
  props: {
    serviceCode: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {}
  }
})
</script>

<style scoped>


</style>
